import { createStyles } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { ButtonLink } from '~/domains/design-system/Button';

import { MarketLinks } from '../../constants/links';

const useStyles = createStyles(() => ({
  button: {
    alignSelf: 'flex-start',
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export function ViewFullRulesButton() {
  const { t } = useTranslation('market');
  const { classes } = useStyles();

  return (
    <ButtonLink
      variant="text"
      size="small"
      href={MarketLinks.FULL_RULES}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.button}
    >
      {t('rules.viewFullRules')}
    </ButtonLink>
  );
}
